










import { defineComponent, computed } from '@vue/composition-api'
import path from 'path'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faFileVideo,
  faFileAudio,
  faFileImage
} from '@fortawesome/free-regular-svg-icons'
library.add(faFileVideo, faFileAudio, faFileImage)

const fileExtensionTypes = {
  mp4: 'video',
  m4v: 'video',
  mp3: 'audio',
  m4a: 'audio',
  jpg: 'image',
  jpeg: 'image',
  png: 'image'
}

const fileExtensionToType = (fileExtension: string) =>
  fileExtensionTypes?.[fileExtension] ?? ''

const fileTypeIcons = {
  video: 'file-video',
  audio: 'file-audio',
  image: 'file-image'
}

const fileTypeToIcon = (fileType: string) =>
  fileTypeIcons?.[fileType] ?? 'question'

export default defineComponent({
  props: {
    fileName: String
  },

  setup(props) {
    const fileType = computed(() => {
      const fileExtension = path.extname(props.fileName)?.slice(1)
      return fileExtensionToType(fileExtension)
    })

    const fileTypeIcon = computed(() => {
      return fileTypeToIcon(fileType.value)
    })

    return {
      fileType,
      fileTypeIcon
    }
  }
})
